import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'User',
    entityNamePlural: 'Users',
    entityNameModule: 'admin',
  }), [])
}
